// extracted by mini-css-extract-plugin
module.exports = {"page":"home_page__1aMaf"};